import qs from 'querystring';
// import { List } from 'immutable';
import mapper from 'object-mapper';
import querystring from 'querystring';
import uuid from 'uuid/v4';
import moment from 'moment';
import { get, post, put, del } from '@/Libs/Request/index'

import { ScheduleRecord, OrderInfoRecord, OrdersRecord, TravellerRecord, BillTransactionRecord } from './../Record/Orders';
import { saveSearchCondition, readSearchCondition, decomposeTBOrders } from './../Libs/Orders';

// const DOMAIN_NAME = 'http://172.21.24.31:3000';
const DOMAIN_NAME = '';
const NAME_SPACE = 'ORDERS/';
let autoOIID = 1;

export const vLoading = (state) => ({
  type: NAME_SPACE + 'V_LOADING',
  payload: {
    state
  }
});

export const modifySaveStatus = (state) => ({
  type: NAME_SPACE + 'MODIFY_SAVE_STATUS',
  payload: {
    state
  }
});

export const receiveInitialState = () => ({
  type: NAME_SPACE + 'RECEIVE_INITIALSTATE'
});

export const editOrders = (orders, oId) => ({
  type: NAME_SPACE + 'EDIT_ORDERS',
  payload: {
    orders,
    oId
  }
});

export const splitPackageM = (order1, record, key1) => {
  console.log('record', record)

  const o_id = order1.o_id;
  const oi_id = 'oi_id_' + (autoOIID++);
  const booking_date = mapper.getKeyValue(order1, 'booking_date') || moment().format('YYYY-MM-DD HH:mm:ss');
  const is_shipment = mapper.getKeyValue(order1, 'is_shipment') || 0;
  order1.oi_id = oi_id;
  const v4 = uuid(`${NAME_SPACE}-${o_id}-ADD_ORDERS-${(localStorage.getItem('userId'))}-${((new Date()).getTime())}`);
  delete order1.orders_info;
  const orders = new OrdersRecord(order1);

  const supplier = { 's_id': record.hm_pp_list[key1].supplier_id, 'company': record.hm_pp_list[key1].supplier_name, 'contacts': record.hm_pp_list[key1].supplier_contacts };
  const destination_paths_name = [];
  destination_paths_name.push(record.hm_pp_list[key1].destination_label);

  const o = orders.update('orders_info', orders_info => orders_info.push(new OrderInfoRecord({ booking_date, o_id, oi_id, order_types: 2, sub_o_id: v4, is_shipment, product_name: record.hm_pp_list[key1].title, departure_date: record.departure_date, num: record.num, supplier: supplier, destination: record.hm_pp_list[key1].destination_id, destination_paths_name: destination_paths_name, supplier_id: record.hm_pp_list[key1].supplier_id })));

  return {
    type: NAME_SPACE + 'ADD_ORDERS',
    payload: {
      orders: o.toJS()
    }
  }

  // const a = t.toJS();

}

export const addOrders = (order1) => {
  const o_id = order1.o_id;
  const oi_id = 'oi_id_' + (autoOIID++);
  const booking_date = mapper.getKeyValue(order1, 'booking_date') || moment().format('YYYY-MM-DD HH:mm:ss');
  const is_shipment = mapper.getKeyValue(order1, 'is_shipment') || 0;
  order1.oi_id = oi_id;
  const v4 = uuid(`${NAME_SPACE}-${o_id}-ADD_ORDERS-${(localStorage.getItem('userId'))}-${((new Date()).getTime())}`);
  delete order1.orders_info;
  const orders = new OrdersRecord(order1);
  const o = orders.update('orders_info', orders_info => orders_info.push(new OrderInfoRecord({ booking_date, o_id, oi_id, order_types: 2, sub_o_id: v4, is_shipment })));
  // const a = t.toJS();
  return {
    type: NAME_SPACE + 'ADD_ORDERS',
    payload: {
      orders: o.toJS()
    }
  }
}

export const thenAddOrders = (o = {}, oi = {}) => {
  const o_id = o.o_id;
  const oi_id = 'oi_id_' + (autoOIID++);
  const v4 = uuid(`${NAME_SPACE}-${o_id}-ADD_ORDERS-${(localStorage.getItem('userId'))}-${((new Date()).getTime())}`);
  let orders;
  orders = new OrdersRecord(Object.assign(o, { 'oi_id': oi_id }));
  orders = orders.update('orders_info', orders_info => orders_info.push(new OrderInfoRecord(
    Object.assign(oi, {
      o_id, oi_id, order_types: 2, sub_o_id: v4
    })
  )));
  return {
    type: NAME_SPACE + 'ADD_ORDERS',
    payload: {
      orders
    }
  }
}

export const editOrdersInfo = (ordersInfo, oId, oIId) => ({
  type: NAME_SPACE + 'EDIT_ORDERSINFO',
  payload: {
    ordersInfo,
    oId,
    oIId
  }
});

export const editOrdersM = (orders, oIId) => ({
  type: NAME_SPACE + 'EDIT_ORDERS_M',
  payload: {
    orders,
    oIId
  }
});

export const editOrdersInfoM = (ordersInfo, oIId) => ({
  type: NAME_SPACE + 'EDIT_ORDERSINFO_M',
  payload: {
    ordersInfo,
    oIId
  }
});

export const delOrdersInfoM = (oId, oIId, isPush) => {
  return (dispatch, getState) => {
    if (isPush === true) {
      dispatch(delQueuePush(oId, oIId))
    }
    if (getState().get('Orders').get('data').size === 1) {
      // console.log(getState().get('Orders').get('data').get(0).toJS());
      dispatch(addOrders(getState().get('Orders').get('data').get(0).toJS()));
    }

    return dispatch({
      type: NAME_SPACE + 'DEL_ORDERSINFO_M',
      payload: {
        oId,
        oIId
      }
    });
  }
};

export const delQueuePush = (oId, oIId = null, oriId = null, obtId = null) => ({
  type: NAME_SPACE + 'DEL_QUEUE_PUSH',
  payload: {
    oId,
    oIId,
    oriId,
    obtId,
  }
});

export const addTraveller = (traveller) => {
  return ({
    type: NAME_SPACE + 'ADD_TRAVELLER',
    payload: {
      traveller: new TravellerRecord(traveller).toJS()
    }
  });
};
export const editTraveller = (traveller, oriId) => ({
  type: NAME_SPACE + 'EDIT_TRAVELLER',
  payload: {
    traveller,
    oriId
  }
});
export const delTraveller = (oId, oriId) => {
  return (dispatch, getState) => {
    dispatch(delQueuePush(oId, null, oriId))
    return dispatch({
      // return ({
      type: NAME_SPACE + 'DEL_TRAVELLER',
      payload: {
        oriId
      }
    });
  }
};
export const addBillTransaction = (payment) => {
  return ({
    type: NAME_SPACE + 'ADD_BILLTRANSACTION',
    payload: {
      payment: new BillTransactionRecord(payment).toJS()
    }
  });
};
export const editBillTransaction = (payment, obtId) => ({
  type: NAME_SPACE + 'EDIT_BILLTRANSACTION',
  payload: {
    payment,
    obtId
  }
});
export const delBillTransaction = (oId, obtId, notNew) => {
  return (dispatch, getState) => {
    if (notNew === true) {
      dispatch(delQueuePush(oId, null, null, obtId))
    }
    return dispatch({
      type: NAME_SPACE + 'DEL_BILLTRANSACTION',
      payload: {
        obtId
      }
    });
  }
};
export const addSchedule = (schedule) => {
  return ({
    type: NAME_SPACE + 'ADD_SCHEDULE',
    payload: {
      schedule: new ScheduleRecord(schedule)
    }
  });
};

export const delSchedule = (id) => {
  return ({
    type: NAME_SPACE + 'DEL_SCHEDULE',
    payload: {
      id
    }
  });
};

export const editGroupTags = (tagIds) => ({
  type: NAME_SPACE + 'EDIT_GROUPTAGS',
  payload: tagIds
});

export const receiveOrders = (orders) => ({
  type: NAME_SPACE + 'RECEIVE_ORDERS',
  payload: orders
});

export const fetchOrdersIfNeeded = (id, addition) => {
  return (dispatch, getState) => {
    const strEx = 'dividers_id=' + (localStorage.getItem('dividersIdCurrent') || '');
    return get(`${DOMAIN_NAME}/api/orders/${id}?${strEx}`)
      .then(res => res.json())
      .then(json => {
        if (json.errno !== 0) {
          return;
        }
        const newJson = {};
        newJson.data = json.data.map(orders => {
          return decomposeOrders(orders.pf_id, orders, addition)
        });
        newJson.data = newJson.data.map((order) => {
          if (Object.keys(order).length > 0) {
            order.orders_info = [order.orders_info].map((item) => {
              if (!Array.isArray(item.package)) {
                return item;
              }
              if (item.package[0] !== undefined) {
                // item.product_name = item.package[0].title;
                item.ptitle = item.package[0].title;
              }
              return item;
            });
          }
          return order;
        });
        if (newJson.data[0] !== undefined) {
          newJson.data[0].orders_info = newJson.data[0].orders_info.map((item) => {
            if (!Array.isArray(item.package)) {
              return item;
            }
            if (item.package[0] !== undefined) {
              // item.product_name = item.package[0].title;
              item.ptitle = item.package[0].title;
            }
            return item;
          });
        }
        newJson.loading = false;
        newJson.delQueue = [];
        dispatch(receiveOrders(newJson));
      });
  }
};


export const receiveOrdersCollection = (orders) => ({
  type: NAME_SPACE + 'RECEIVE_ORDERS_COLLECTION',
  payload: orders
});

export const fetchProductsPriceIfNeeded = (code, supplier_id, oId, oIId, datePrice = '', cb) => {
  return (dispatch, getState) => {
    // dispatch(vLoading(true));
    get(`${DOMAIN_NAME}/api/products/${code}/price`, {}, { headers: { 'supplier_id': supplier_id, 'datePrice': datePrice } })
      .then(res => res.json())
      .then(json => {
        if (json.errno !== 0) {
          return;
        }
        const data = json.data;
        dispatch(vLoading(false));
        // const _state = getState().toJS();
        if (oId !== '') {
          dispatch(editOrders({
            exchange_rate: undefined,
            currency_id: data.currency_id,
          }, oId));
        }
        dispatch(editOrdersInfoM({
          price: {
            adult_cost_price: data.adult_cost_price,
            child_cost_price: data.child_cost_price,
            diff_cost_price: data.diff_cost_price,
            exchange_rate: data.exchange_rate,
            currency_id: data.currency_id,
            insurance: data.insurance,
            insurance_included: data.insurance_included,
          }
        }, oIId));
      });
  }
}

export const fetchOrdersCollectionIfNeeded = (pagination = { page: 1 }, initValue = {}, fixedValue = {}, w = false) => {
  return (dispatch, getState) => {
    // const _fixedValue = qs.parse('dividers_id=' + (localStorage.getItem('dividersIdCurrent') || ''));
    // fixedValue = Object.assign(_fixedValue, fixedValue);
    let cValue;
    cValue = qs.parse(readSearchCondition());
    cValue = Object.assign(initValue, cValue);
    cValue = Object.assign(cValue, fixedValue);
    const strEx = qs.stringify(cValue);
    if (w) {
      saveSearchCondition(strEx);
    }
    return get(`${DOMAIN_NAME}/api/orders?${strEx}`, {}, { headers: { mode: "no-cors", 'page': pagination.page } })
      .then(res => res.json())
      .then(json => {
        if (json.errno !== 0) {
          return;
        }
        json.data.loading = false;
        dispatch(receiveOrdersCollection(json.data));
      });
  }
};


export const fetchOrdersSearch = (str, initValue = {}, fixedValue = {}) => {
  return (dispatch, getState) => {
    // const form = qs.parse(str);
    // const _fixedValue = form.dividers_id ? form.dividers_id : { 'dividers_id': localStorage.getItem('dividersIdCurrent') || '' };
    // fixedValue = Object.assign(_fixedValue, fixedValue);
    let cValue;
    // cValue = qs.parse(readSearchCondition());
    cValue = Object.assign(initValue, cValue);
    cValue = Object.assign(cValue, initValue);
    cValue = Object.assign(cValue, qs.parse(str));
    cValue = Object.assign(cValue, fixedValue);
    const strEx = qs.stringify(cValue);
    console.log(strEx);
    saveSearchCondition(strEx);
    return get(`${DOMAIN_NAME}/api/orders?${strEx}`)
      .then(res => res.json())
      .then(json => {
        if (json.errno !== 0) {
          return;
        }
        json.data.loading = false;
        dispatch(receiveOrdersCollection(json.data));
      });
  }
}

export const fetchOrdersEdit = (orders, cb) => {
  return (dispatch, getState) => {
    orders.changed_by_id = localStorage.getItem('userId');
    // dispatch(vLoading(true));
    return new Promise((resolve) => {
      put(`${DOMAIN_NAME}/api/orders`, orders )
      .then(res => res.json())
        .then(json => {
          if (json.errno !== 0) {
            return;
          }
          if (typeof cb === 'function') {
            cb(null, json);
          }
          resolve(json);
          //dispatch(addProducts(products));
        });
    });
  }
}

export const fetchOrdersDelete = (ids) => {
  return (dispatch) => {
    ids.changed_by_id = localStorage.getItem('userId');
    dispatch(vLoading(true));
    return del(`${DOMAIN_NAME}/api/orders/${ids.oid}`, ids)
      .then(res => res.json())
      .then(json => {
        if (json.errno !== 0) {
          return;
        }
        return Promise.resolve(json);
        //dispatch(addProducts(products));
      });
  }
}

export const fetchCheckGroupsCode = (code) => {
  return (dispatch, getState) => {
    return get(`${DOMAIN_NAME}/api/groups/${encodeURIComponent(code)}`)
      .then(res => res.json())
      .then(json => {
        if (json.errno !== 0) {
          return;
        }
        console.log(json);
        //dispatch(addProducts(products));
      });
  }
}

export const fetchGeneratorGroupsCode = (paramsStr, oIId) => {
  return (dispatch, getState) => {
    return get(`${DOMAIN_NAME}/api/groups/tool/generator-code?${paramsStr}`)
      .then(res => res.json())
      .then(json => {
        if (json.errno !== 0) {
          return;
        }
        if (json.data === '') {
          alert('团号重复');
        }
        dispatch(editOrdersM({
          groups_code: json.data,
          groups_no: json.data
        }, oIId));
      });
  }
}

export const fetchSyncOrders = (tid, pf_id, page) => {
  return (dispatch, getState) => {
    return get(`${DOMAIN_NAME}/api/orders?type=sync&tid=${tid}&pf_id=${pf_id}`)
      .then(res => res.json())
      .then(json => {
        if (json.errno !== 0) {
          return;
        }
        if (json.data === 1) {
          console.log('ok');
        }
        setTimeout(() => dispatch(fetchOrdersCollectionIfNeeded(page)), 6000);
        // dispatch(fetchOrdersCollectionIfNeeded({ page }));
      });
  }
}

export const fetchOrdersArrangementCollectionIfNeeded = (code) => {
  let str;
  let obj = {
    arrangement: code,
    type: 'search'
  };
  if (code === -1) {
    obj.arrangement = '0,1';
  }
  let qs = querystring.parse(readSearchCondition());
  str = querystring.stringify(Object.assign(qs, obj));
  return (dispatch) => {
    dispatch(vLoading(true));
    dispatch(fetchOrdersSearch(str));
  }
};

export const fetchOrdersStatisticalDataIfNeeded = (initValue = {}, fixedValue = {}, cb = () => { }) => {
  return () => {
    // const _fixedValue = qs.parse('dividers_id=' + (localStorage.getItem('dividersIdCurrent') || ''));
    // fixedValue = Object.assign(_fixedValue, fixedValue);
    let cValue = qs.stringify(readSearchCondition());
    cValue = qs.parse(readSearchCondition());
    cValue = Object.assign(initValue, cValue);
    cValue = Object.assign(cValue, fixedValue);

    const strEx = qs.stringify(cValue);
    return get(`${DOMAIN_NAME}/api/orders/statistical-data?${strEx}`)
      .then(res => res.json())
      .then(json => {
        if (json.errno !== 0) {
          return;
        }
        cb('', json.data);
      });
  }
}

export const fetchOrdersStatisticalData = (initValue = {}, fixedValue = {}, cb = () => { }) => {
  return () => {
    // const _fixedValue = qs.parse('dividers_id=' + (localStorage.getItem('dividersIdCurrent') || ''));
    // fixedValue = Object.assign(_fixedValue, fixedValue);
    let cValue = qs.stringify(readSearchCondition());
    cValue = qs.parse(readSearchCondition());
    cValue = Object.assign(initValue, cValue);
    cValue = Object.assign(cValue, fixedValue);

    const strEx = qs.stringify(cValue);
    return get(`${DOMAIN_NAME}/api/statistics/orders-summary?${strEx}`)
      .then(res => res.json())
      .then(json => {
        if (json.errno !== 0) {
          return;
        }
        cb('', json.data);
      });
  }
}

export const fetchOrdersOperatorBatchConfirm = ({ oId, oIId, val }) => {
  return () => {
    const url = `/api/tool/orders/batch-confirm?oi_id=${oIId}&is_operator_confirm=${val}&confirm_type=operator`
    get(url, {}, { cache: 'no-store', headers: { 'Content-Type': 'application/html' } })
      .then(response => {
        if (response.ok) {
        }
      });
  }
}

export function decomposeOrders(type, orders, addition) {
  return decomposeTBOrders(orders, addition);
  /*
  switch (type) {
    case 1:
      return decomposeTBOrders(orders, addition);
    default:
      return [];
  }
  */
}

/**
 * @param obj { agency, ids }
 */
export const fetchOrdersOperatorBatchAgency = (obj) => {
  return (dispatch, getState) => {
    const url = `${DOMAIN_NAME}/api/orders/agency`;
    return put(url, obj)
      .then((res) => res.json())
      .then((json) => {
        if (json.errno !== 0) {
          return;
        }
        return Promise.resolve(json.data);
      });
  };
}
